import {decorate, observable} from 'mobx';
import {BaseModel} from './base';

export class MessageRead extends BaseModel {
  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);
    this.user = rootStore.userStore.getById(this.userId);
  }

  searchableProperties = [];
}

decorate(MessageRead, {
  id: observable,
  user: observable,
  userId: observable,
  messageId: observable,
  timestamp: observable,
});
